export const enableScroll = () => {
    document.body.style.overflowY = 'auto';
    document.body.style.position = 'static';
    window.scrollTo(0, Math.abs(parseFloat(document.body.style.top)));
};

export const disableScroll = () => {
    document.body.style.overflowY = 'scroll';
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.position = 'fixed';
    document.body.style.right = '0';
    document.body.style.left = '0';
};
